module.exports = __webpack_public_path__ + "media/customizations/bridgelandlife/logo-6dcb401854040aa473a33d560a5897c5.png";